
import React, {Component} from 'react';
import axios from 'axios';
import {ToastContainer, ToastStore} from 'react-toasts';

import {SERVER_URL}  from '../Constants';
import LostItemFunctions from '../LostItem/LostItemFunctions';


class PrintStatement extends Component {
  constructor(props) {
    super(props);

    this.state = {
        srId:'',
        name: '',
        serviceFee:0,
        shippingAddress: '',
        shippingAddress2: '',
        shippingCity: '',
        shippingState: '',
        shippingPostalCode: '',
        shippingCountry: '',
        shippingPhone: '',
        mainPhone:'',
        base64Icon: '',
        billingAddress: '',
        recipient:'',
        dateReceived:'',
        barcodeValue:'',
        storageLocation:'',
        loading:true,
        parcelRef:'',
        parcelGroupTotalCount: 0,
        parcelGroupNum: 0,
        picUrl:'',
        signUrl:'',
        roomNumber:'',
        arrivalDate:'',
        billingTotal:0,
      
    };
  }

  async componentDidMount() {
    
    console.log('print id=' + this.props.match.params.ids);
   
    var token = '';
    var vid = '';
    var srIds = [];

    if (this.props.match.params.ids){
        var params = this.props.match.params.ids.split('&');
        console.log(params);
        srIds= params[0].split(',');
        token= params[1].split('=')[1];
        vid= params[2].split('=')[1];
    }else{
      return (
        <div> Invalid ID </div>
      );
    }
      // Load the SRITem from the server  
      console.log(`${SERVER_URL}/SR/sritems/`);
      let results = (await axios.post(`${SERVER_URL}/SR/sritems/`,{ids:srIds}, {headers: { 'Authorization': `Bearer ${token}`,'venueid': `${vid}`  }})).data;
      let venue = (await axios.get(`${SERVER_URL}/venue/${vid}`, {headers: { 'Authorization': `Bearer ${token}` }})).data;
   
      let srItems = results.srItems;
      
      console.log('IDs: ' + srIds);
      if (srItems===undefined || venue===undefined){
          return( <div> Item ID or login not valid to load this invoice. </div>);
      }
      console.log(srItems);

      this.setState({
                srItems:srItems,
                billingTotal:results.billingTotal,
                totalAmount:results.totalAmount,
                loading:false,
                //srId: srItem.id,
                //recipient:srItem.recipient,
                //dateReceived:srItem.dateReceived,
                name: venue.name,
                active:venue.active,
                publishId:venue.publishId,
                venueDescription:venue.venueDescription,
                shippingAddress: venue.shippingAddress,
                shippingAddress2: venue.shippingAddress2,
                shippingCity: venue.shippingCity,
                shippingState: venue.shippingState,
                shippingPostalCode: venue.shippingPostalCode,
                shippingCountry: venue.shippingCountry,
                shippingPhone: venue.shippingPhone,
                mainPhone:venue.mainPhone,
                base64Icon: venue.base64Icon,
                billingAddress: venue.billingAddress,
                /*serviceFee: srItem.serviceFee,
                barcodeValue:srItem.barcodeValue,
                storageLocation:srItem.storageLocation,
                parcelRef:srItem.parcelRef,
                parcelGroupTotalCount: srItem.parcelGroupTotalCount,
                parcelGroupNum:srItem.parcelGroupNum,
                picUrl: (srItem.picUrl==='') ? '../default-placeholder.png' : srItem.picUrl, 
                signUrl: (srItem.signUrl==='') ? undefined : srItem.signUrl,
                arrivalDate: srItem.arrivalDate,
                roomNumber:srItem.roomNumber,
                parcelSize:srItem.parcelSize,
                */
      });


  }
  handleDismiss=()=> {
    this.setState({ showAlert: false });
  }
  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}
trimBarcode=(barcodeStr)=>{
    if (barcodeStr){
      try{
        let length = 25
       if (barcodeStr.length > 25){
         return barcodeStr.substring(0,length) + '...';
       }else{
         return barcodeStr;
       }
      }catch(e){
        return '';
      }
    }else{
      return '';
    }
  }

   formatDateTime=(d)=>{
    try {
        if (d){
            var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            let cellDate = new Date(d);
            return cellDate.toLocaleDateString([],options) +  ' at ' + cellDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }
  formatDate=(d)=>{
    try {
        if (d){
            var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            let cellDate = new Date(d);
            return cellDate.toLocaleDateString([],options) ;
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }

  formatMoney=(val)=> {
    if (!Number.isNaN(val) && val >0){
        return LostItemFunctions.formatMoney(val)
       }else{
           return LostItemFunctions.formatMoney(0)
       }
    
  }


  createStatementtableOfSrItems=()=>{
    if (this.state.srItems){
        return this.state.srItems.map((item, index) => {
            return (
                <tr key={index}>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.serviceFee}</td>
                    <td>{item.dateReceived}</td>
                    <td>{item.barcodeValue}</td>
                    <td>{item.storageLocation}</td>
                    <td>{item.parcelRef}</td>
                    <td>{item.parcelGroupNum} of {item.parcelGroupTotalCount}</td>
                    <td>{item.parcelSize}</td>
                    <td>{item.roomNumber}</td>
                    <td>{this.formatDateTime(item.arrivalDate)}</td>
                </tr>
            )
        })
    }
  };

  render() {
    if (this.state.loading===true){
        return (
        
            <div className="container text-center">
           
            <br/>
            <h3 className='text-info'>Loading ...</h3>
      
            </div>
             
          )
    }
   else{

    return (

    
        <div style={{margin:'10px'}}>
        
         <div className='row text-center'>
            <div className='col text-center'> 
               <img style={{width: '200px', height:'200px'}} src={this.state.base64Icon} alt=''/> 
               <br/>
                <p className='text-primary' style={{fontSize:18, color:'black'}}>{this.state.name} </p>
                
           </div>
        </div>    
        <br/>
        <div className='row justify-content-md-center'>
            <div className='col-12 text-center'> 
                <p style={{fontSize:18, color:'black', fontWeight:'bold'}}><h3>Package Handling Statement</h3></p>
                
               
                <hr/>
           </div>
        </div>    
      

                  
        <br/>
      
        <div className='row justify-content-md-center' >
            <div className='col-12 text-center'> 
                <div>
                    <h3 className='text-muted text-left'>Details</h3>
                    <hr />
                    <br/>
                    
                    <table className='table-sm' style={{width:'100%'}}>
                        <thead>
                            <tr>
                            <th style={{fontSize:18, color:'black', fontWeight:'normal', }}>#</th>
                                <th style={{fontSize:20, color:'black', fontWeight:'normal',  textAlign:'left'}}><b><u>Name</u></b></th>
                                <th style={{fontSize:20, color:'black', fontWeight:'normal',  textAlign:'left'}}><b><u>Group</u></b></th>
                                <th style={{fontSize:20, color:'black', fontWeight:'normal'}}><b><u>Tracking Number</u></b></th>
                                <th style={{fontSize:20, color:'black', fontWeight:'normal', textAlign:'right'}}><b><u>Fee</u></b></th>
                            </tr>
                        </thead>
                        <tbody style={{overflowY:'scroll',display:'table-row-group',height:'350px'}}>
                            {this.state.srItems && this.state.srItems.map((parcelItem, index) => {
                                let counter =index+1;
                                return (
                                    <tr key={parcelItem.id}>
                                         <td style={{fontSize:15, color:'black', fontWeight:'normal', textAlign:'center'}}><span >{counter}</span></td>
                                        <td style={{fontSize:15, color:'black', fontWeight:'normal', textAlign:'left'}}><span >{parcelItem.recipient}</span></td>
                                        <td style={{fontSize:15, color:'black', fontWeight:'normal', textAlign:'left'}}><span >{parcelItem.groupName}</span></td>
                                        <td><small>{parcelItem.barcodeValue}</small></td>
                                        <td className='text-right'><span style={{fontSize:15, color:'black', fontWeight:'normal'}}><b>{this.formatMoney(parcelItem.serviceFee)}</b></span></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
           </div>
          


        </div>    
        <br/> <br/>
        <div className='row justify-content-md-center' >
            <div className='col-12 text-center'> 
                <div>
                    <h3 className='text-muted  text-left'>Service Charge Summary</h3>
                    <hr />
                    <br/>
                    
                   
                        
                             <div className='row text-center'>
                                <div className='col text-left'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>Total: </p> </div>
                                <div className='col text-right'><p className='text-primary' style={{fontSize:18, color:'black', fontWeight:'bold'}}>{this.formatMoney(this.state.totalAmount)}</p> </div>
                            </div>
                            <hr />
                   
                </div>
            </div>
        </div>      
                
       
          <div className='row' style={{bottom:0, left:0,width:'100%',position:'fixed', textAlign:'center' }}>
            <div className='col text-center'> 
                  
   
                    <p className='text-secondary' style={{fontSize:14}}>{this.state.shippingAddress + ' ' + this.state.shippingAddress2 + ' ' + this.state.shippingCity + ' ' + this.state.shippingState + '. ' + this.state.shippingPostalCode +'      tel:' + this.state.mainPhone} </p>
            </div>
         </div>
      </div>

    )
   }
  }
}

export default PrintStatement;